<template>
<div class="about-wrap">
  <div class="container main-1">
    <aside class="left">
      <div @click="link(item.id)" :to="{ query: { id: item.id } }" class="item clearfix" :class="{ active: active(item.id) }" v-for="item of data" :key="item.id">
        <p class="left">{{ item.name }}</p>
        <p class="right" v-if="item.id === 20">
          <i class="el-icon-arrow-right"></i>
        </p>
      </div>
    </aside>
    <main class="left" v-if="rightData">
      <h3>{{ rightData.name }}</h3>
      <div class="content-box" v-html="rightData.content"></div>
    </main>
  </div>
</div>
</template>

<script>
export default {
  scrollToTop: true,
  watchQuery: ['type', 'id'],
  async asyncData ({ query, $axios }) {
    let type = query.type ? 2: 1
    let data = null
    let rightData = null
    try {
      let res = await $axios._get('/Common/Abmenu', { type })
      data = await res.filter(_ => _.status !== 0)
      let id = query.id || data[0].id
      rightData = await $axios._get('/Common/Menucontent', { id })
      // console.log(rightData, id)
    } catch (err) {
      console.log(err)
    }
    return {
      data,
      rightData: rightData || null
    }
  },
  head () {
    return {
      title: '关于我们_一富财经_专注理财知识普及_陪伴市场健康成长',
      meta: [
        { hid: 'keywords', name: 'keywords', content: '实时行情_投资者交流_趋势解盘_深度分析' },
      ]
    }
  },
  methods: {
    link (id) {
      if (id === 20) {
        this.$router.push({ query: { type: 2 } })
      } else {
        this.$router.push({ query: { id, type: this.$route.query.type } })
      }
    },
    active (id) {
      let itemId = +this.$route.query.id || this.data[0].id
      return id === itemId
    }
  }
}
</script>

<style lang="less">
.about-wrap {
  padding: 25px 0; background-color: #f2f2f2;
  .container {
    overflow: hidden; background-color: #fff;
    aside {
      width: 200px; border-right: 1px solid #eaeaea; padding-bottom: 2000px; margin-bottom: -2000px;
      .item {
        padding: 0 20px 0 30px; line-height: 40px; cursor: pointer; color: #666666; border-bottom: 1px solid #eaeaea; font-size: 14px;
        &.active {
          color: #ffffff; background-color: #e43a3d; border-bottom-color: #e43a3d;
        }
      }
    }
    main {
      width: 1000px;
      h3 {
        background-color: #f3ebe8; padding-left: 20px; line-height: 40px; font-size: 16px; color: #e43a3d;
      }
      .content-box {
        padding: 20px;
        img {
          max-width: 100%; height: auto;
        }
      }
    }
  }
}
</style>
